import React from 'react';
import { Carousel } from 'react-bootstrap';
import firstSlide from "../assets/certificate/cev.jpg";
import secondSlide from "../assets/certificate/coursera.jpg";
import thirdSlide from "../assets/certificate/machine.jpg";
import fourthSlide from '../assets/certificate/vidulcert.jpeg';
import styled from 'styled-components';

const Styles = styled.div`
    .imagestyle {
        width: 70%;
        height: auto;
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .carousel {
  width:100%;
  margin: auto;
}

.carousel-control-next,
.carousel-control-prev /*, .carousel-indicators */ {
    filter: invert(100%);
}

`;
export const SlideShow2 = () => (
    <Styles>
    <Carousel className="carousel">
        <Carousel.Item>
            <img 
                className="imagestyle"
                src={firstSlide}
                alt="CEV"
 
            />
            <Carousel.Caption>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img 
                className="imagestyle"
                src={secondSlide}
                alt="Coursera1"
 
            />
            <Carousel.Caption>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img 
                className="imagestyle"
                src={thirdSlide}
                alt="Coursera2"
 
            />
            <Carousel.Caption>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img 
                className="imagestyle"
                src={fourthSlide}
                alt="vidul Cert"
 
            />
            <Carousel.Caption>
            </Carousel.Caption>
        </Carousel.Item>
    </Carousel>
    </Styles>
)